export default __webpack_public_path__ + "static/media/object-comment_darkGray3.54fb24f1.svg";